import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=dc4d80be&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=dc4d80be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4d80be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc4d80be')) {
      api.createRecord('dc4d80be', component.options)
    } else {
      api.reload('dc4d80be', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=dc4d80be&scoped=true&", function () {
      api.rerender('dc4d80be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-45L4qOw433b4x/JS/comp/PopupDialog.vue"
export default component.exports